import React, { useEffect, useState } from "react";
import { Header } from "../../internal/Header/Header";
import _ from "lodash";
import useCartCount from "../../../hooks/useCartCount";
import { useLocation } from "@reach/router";

const Index = ({ children, hideSidebar }) => {
  const [caseType, setCaseType] = useState();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { stats } = useCartCount();

  useEffect(() => {
    if (!_.isEmpty(stats)) {
      if (!!searchParams.get("caseType")) {
        setCaseType(searchParams.get("caseType"));
      } else {
        if (stats?.negotiationCount > 0) {
          setCaseType("negotiation");
        } else if (stats?.mediationCount > 0) {
          setCaseType("mediation");
        } else if (stats?.arbitrationCount > 0) {
          setCaseType("arbitration");
        } else {
          setCaseType("negotiation");
        }
      }
    }
  }, [searchParams, stats]);

  return (
    <Header
      showSidebar={!hideSidebar}
      selectedItem="my_cases"
      selectedSubItem={caseType}
    >
      {children}
    </Header>
  );
};

export default Index;
